(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueForcedDialog',QueueForcedDialog);

    QueueForcedDialog.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueForcedDialog($uibModalInstance, entity, Queue) {
        var vm = this;
        vm.queue;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queue = entity;
            });
        }


        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmForced = function (id) {
            Queue.forceComplet({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
